import _ from 'lodash';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import Item from './item';

import {
  Container,
  Header,
  ItemsNumber,
  Text,
} from './styles';

const Category = (props) => {
  const { testSessionCategory, hideCardName } = props;

  const {
    cardSortCategory: { name },
    testSessionCardSortItems,
  } = testSessionCategory;

  const itemsLength = useMemo(() => testSessionCardSortItems.length, [testSessionCardSortItems]);

  return (
    <Container>
      <Header>
        <Text>{name}</Text>
        <ItemsNumber>{itemsLength}</ItemsNumber>
      </Header>

      {!_.isEmpty(testSessionCardSortItems) && _.map(testSessionCardSortItems, (testSessionItem) => (
        <Item
          key={testSessionItem.id}
          item={testSessionItem.cardSortItem}
          hideCardName={hideCardName}
        />
      ))}
    </Container>
  );
};

Category.propTypes = {
  testSessionCategory: PropTypes.shape({
    cardSortCategory: PropTypes.shape({
      name: PropTypes.string,
    }),
    testSessionCardSortItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        itemOrder: PropTypes.number,
        cardSortItem: PropTypes.shape({
          id: PropTypes.string,
        }),
      }),
    ),
  }).isRequired,
  hideCardName: PropTypes.bool.isRequired,
};

export default Category;
